<template>
    <div class="white-bg relative">
<!--        <div class="ranking-title absolute">达人排行榜</div>-->
        <div class="rankingTab">
            <ul>
                <li :class="{ 'item': show, 'active': isMoney }" @click="showMoney"><span></span>赏金榜</li>
                <li :class="{ 'item': show, 'active': isFlow }" @click="showFlow"><span></span>流量榜</li>
            </ul>
        </div>
        <ul class="RankingList" v-show="isMoney">
            <li class="item flex align-items" v-for="(item,index) in darenMoneyRank.slice(0, 10)" :key="item.id">
                <p class="position icon">
                    <img src="@/assets/images/one-icon.png" v-if="index===0">
                    <img src="@/assets/images/two-icon.png" v-if="index===1">
                    <img src="@/assets/images/three-icon.png" v-if="index===2">
                    <i v-if="index===3">4</i>
                    <i v-if="index===4">5</i>
                    <i v-if="index===5">6</i>
                    <i v-if="index===6">7</i>
                    <i v-if="index===7">8</i>
                    <i v-if="index===8">9</i>
                    <i v-if="index===9">10</i>
                </p>
                <p class="head-portrait"><img :src="item.head_img" class="img"></p>
                <p class="name ellipsis">{{item.nickname}}</p>
                <p class="number">￥{{item.num}}</p>
            </li>
        </ul>
        <ul class="RankingList" v-show="isFlow">
            <li class="item flex align-items" v-for="(item,index) in darenClickRank.slice(0, 10)" :key="item.id">
                <p class="position icon">
                    <img src="@/assets/images/one-icon.png" v-if="index===0">
                    <img src="@/assets/images/two-icon.png" v-if="index===1">
                    <img src="@/assets/images/three-icon.png" v-if="index===2">
                    <i v-if="index===3">4</i>
                    <i v-if="index===4">5</i>
                    <i v-if="index===5">6</i>
                    <i v-if="index===6">7</i>
                    <i v-if="index===7">8</i>
                    <i v-if="index===8">9</i>
                    <i v-if="index===9">10</i>
                </p>
                <p class="head-portrait"><img :src="item.head_img" class="img"></p>
                <p class="name ellipsis">{{item.nickname}}</p>
                <p class="number">{{item.num}}</p>
            </li>
        </ul>
    </div>
</template>
<script>
import {homeData} from '@/config/api.js'
export default {
  name: 'DarenRanking',
  data () {
    return {
        darenClickRank: [{
            nickname: '',
            head_img: '',
            num: ''
        }],
        darenMoneyRank: [{
            nickname: '',
            head_img: '',
            num: ''
        }],
        activeName: 'first',
        show: true,
        isMoney: true,
        isFlow: false
    }
  },
    methods: {
        getDarenClickRank () {
            let data = {
            };
            this.$post(homeData,data)
                .then(res => {
                    this.darenClickRank = res.data.darenClickRank;
                    this.darenMoneyRank = res.data.darenMoneyRank;
                })
                .catch(err => {
                    window.console.log("err", err);
                });
        },
        showMoney () {
            this.isMoney = true;
            this.isFlow = false;
        },
        showFlow () {
            this.isMoney = false;
            this.isFlow = true;
        }
    },
  mounted () {
      this.getDarenClickRank()
  }
}
</script>
<style>
    .ranking-title{left:20px;top:0;line-height:46px;font-size:14px;}
    .ranking-tabs .el-tabs__nav{margin-left:20px;}
    .ranking-tabs .el-tabs__item:last-child{margin-right:20px;}
    .el-tabs__nav-wrap::after{height:1px;}
    .RankingList .item{border-bottom:1px #eee solid;padding:12px 20px;}
    /*.RankingList .item:first-child{padding-top:0;}*/
    .RankingList .item .position{width:24px;}
    .RankingList .item .head-portrait{margin:0 10px;width:26px;}
    .RankingList .item .head-portrait .img{width: 26px;height:26px;border-radius:50%;}
    .RankingList .item .name{width:220px;}
    .RankingList .item .number{width:80px;text-align: right;}
    .RankingList .item .icon i{display:block;width:24px;height:24px;line-height:24px;border-radius:100%;background:#eee;text-align: center;}
    .rankingTab ul{border-bottom:1px #eee solid;}
    .rankingTab .item{width:50%;display:inline-block;text-align: center;height:46px;line-height:46px;font-size: 14px;cursor: pointer;}
    .rankingTab .active{color:#FF741F; position:relative;}
    .rankingTab .active span{position: absolute;width:40px;height:2px;background: #FF741F;bottom:-1px;}
</style>
